import { useMemo } from 'react';
import { useOpinionChartEvents } from './useOpinionChartEvents';
import { isOpinionEventDateRangeExceeded } from './utils/isOpinionEventDateRangeExceeded';
import type { IUseOpinionChartEventsParams } from './types';

export function useOpinionChartEventsWithDateLimit(
  params: IUseOpinionChartEventsParams,
) {
  const { enabled = true, startTime, endTime, ...rest } = params;
  const isEventDateRangeExceeded = isOpinionEventDateRangeExceeded(
    startTime,
    endTime,
  );

  const {
    eventData,
    chartEventSetting,
    changeEventSetting,
    settingStorageKey,
    loading,
    error,
    refetch,
  } = useOpinionChartEvents({
    ...rest,
    startTime,
    endTime,
    enabled: enabled && !isEventDateRangeExceeded,
  });

  const limitedChartEventSetting = useMemo(() => {
    if (!isEventDateRangeExceeded) {
      return chartEventSetting;
    }

    return {
      ...chartEventSetting,
      showEventAxis: false,
      showEventBubbles: false,
    };
  }, [chartEventSetting, isEventDateRangeExceeded]);

  return {
    eventData,
    chartEventSetting: limitedChartEventSetting,
    changeEventSetting,
    settingStorageKey,
    loading: isEventDateRangeExceeded ? false : loading,
    error,
    refetch,
    isEventDateRangeExceeded,
  };
}
